// @ts-nocheck

'use client';

import React, { useState } from 'react';

import * as S from './AuthenticationHandler.styles';

import AuthenticationLogin from './Login/Login.component';
import AuthenticationRegister from './Register/Register.component';
import ResetPassword from './ResetPassword/ResetPassword.component';

import { useUserMeta } from '../../../contexts/UserMeta.context';

const AuthenticationHandler = ({ authorize }: { authorize: (authToken: string) => Promise<any> }) => {
  const [ template, setTemplate ] = useState('login');
  const { webAuthClient } = useUserMeta();
  
  const renderTemplate = (template: string): JSX.Element => {
    switch (template) {
      case 'login':
        return <AuthenticationLogin webAuthClient={webAuthClient} setTemplate={setTemplate} authorize={authorize} />;
      case 'register':
        return <AuthenticationRegister setTemplate={setTemplate} webAuthClient={webAuthClient} authorize={authorize} />;
      case 'reset-password':
        return <ResetPassword webAuthClient={webAuthClient} setTemplate={setTemplate} />;
      default:
        return <AuthenticationLogin webAuthClient={webAuthClient} setTemplate={setTemplate} authorize={authorize} />;
    }
  }
  
  return (
    <S.AuthenticationHandler>
      {renderTemplate(template)}
    </S.AuthenticationHandler>
  );
}

export default AuthenticationHandler
